var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * FilterFilled icon component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconFilterFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.87783 1.1001C1.58632 1.1001 1.31925 1.26302 1.18586 1.52222C1.05247 1.78142 1.07513 2.09343 1.24457 2.33064L8.88175 13.0227V22.1119C8.88175 22.3989 9.03971 22.6626 9.29276 22.798C9.5458 22.9334 9.85284 22.9186 10.0916 22.7594L14.7609 19.6465C14.9774 19.5023 15.1075 19.2593 15.1075 18.9991V13.0227L22.7447 2.33064C22.914 2.09343 22.9368 1.78142 22.8034 1.52222C22.67 1.26302 22.4029 1.1001 22.1114 1.1001H1.87783Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconFilterFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconFilterFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconFilterFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-filter-filled') === undefined) {
    customElements.define('cat-icon-filter-filled', BlocksIconFilterFilled);
}
